import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSpring, animated } from '@react-spring/web';
import VolumeIcon, { MuteIcon } from './VolumeIcon';
// import './volume.style.css';

interface IVolumeControl {
    value: number;
    handleVolume: (event: Event, newValue: number | number[]) => void;
    onTapVolumeIcon?: () => void;
    isMute?: boolean;
}

const useStyles = makeStyles({
    sliderRoot: {
        backgroundColor: 'transparent', // Set the background color to transparent
    },
});

export const VolumeControl: React.FC<IVolumeControl> = ({ value, handleVolume, onTapVolumeIcon, isMute }) => {
    const classes = useStyles();
    const [anchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [showSlider, setShowSlider] = useState(true);
    const volumeIconId = open ? 'volume-icon-popover' : undefined;
    const [isSliderBeingUsed, setIsSliderBeingUsed] = useState(false);

    const springPropsSlider = useSpring({
        transform: showSlider ? 'translateY(0)' : 'translateY(100%)',
        opacity: showSlider ? 1 : 0,
        config: { tension: 300, friction: 20 },
    });

    const handleVolumeIconClick = (event: React.MouseEvent<HTMLElement>) => {
        onTapVolumeIcon && onTapVolumeIcon();
    };

    useEffect(() => {
        let timer: any;
        if (showSlider && isSliderBeingUsed) {
            timer = setTimeout(() => {
                setShowSlider(false);
            }, 4000); // Hide slider after 4 seconds if not touched
        } else {
            clearTimeout(timer);
        }
        return () => clearTimeout(timer);
    }, [showSlider, isSliderBeingUsed]);

    const handleVolumeToggle = (event: Event, newValue: number | number[]) => {
        handleVolume(event, newValue);
        setIsSliderBeingUsed(true);
    };

    //TODO Change the below from Grid To Box, Throwing error in mobile screen

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={1}>
                <Grid item>
                    <IconButton
                        aria-describedby={volumeIconId}
                        size="medium"
                        onClick={handleVolumeIconClick}
                        sx={{
                            color: '#fff',
                            fontSize: 24,
                        }}>
                        {isMute ? <MuteIcon height={24} width={24} /> : <VolumeIcon />}
                    </IconButton>
                </Grid>
                {!isMute && (
                    <Grid item>
                        <animated.div style={{ ...springPropsSlider, marginLeft: -10, position: 'relative' }}>
                            <Slider
                                value={typeof value === 'number' ? value : 0}
                                classes={{ root: classes.sliderRoot }}
                                onChange={handleVolumeToggle}
                                onChangeCommitted={() => setIsSliderBeingUsed(false)}
                                aria-labelledby="input-slider"
                                max={1}
                                min={0}
                                size="medium"
                                step={0.1}
                                style={{
                                    width: '80px',
                                }}
                            />
                        </animated.div>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};
